import { SingleEmailValidationStatus } from '@zeuslabsltd/common/lib/business/model/common/single-email-validation';
import { apiRepo } from 'src/business/repo/api-repo';

class SingleEmailValidationService {
	async validate(email: string): Promise<boolean> {
		const allowedMailerCheckStatuses = [
			SingleEmailValidationStatus.VALID,
			SingleEmailValidationStatus.CATCH_ALL,
			SingleEmailValidationStatus.MAILBOX_FULL,
			SingleEmailValidationStatus.UNKNOWN,
			SingleEmailValidationStatus.ROLE,
		];

		const result = await apiRepo().Public.validateEmail({ email });
		const status = result.status as SingleEmailValidationStatus;
		return allowedMailerCheckStatuses.includes(status);
	}
}
export const singleEmailValidationService = (): SingleEmailValidationService => new SingleEmailValidationService();
